export default "__VITE_ASSET__1754ef37__"